import axios from 'axios';
axios.defaults.withCredentials = true;
import { fetchToken } from '../fetchToken';
const API_URL = process.env.EMAILS_API_URL;

/**
   * Checks if client is compatible.
   * @return {boolean} whether or not the client version is valid.
*/
export const validateClientVersion = async () => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: API_URL + 'client/version',
    headers: {
      'Content-Type': 'application/json',
      'docrio-email-client-version': process.env.VERSION,
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    await axios(config);
    return true;
  } catch (e) {
    if (e.response?.status === 422) {
      return false;
    }
    // Don't block for other errors
    return true;
  }
};

/**
 * Retrieves PKCE values from the backend for the Salesforce OAuth flow.
 * Called before initiating the authorize redirect — no auth token required.
 * @return {{ encryptedVerifier: string, codeChallenge: string, codeChallengeMethod: string }}
 */
export const getSalesforcePkce = async () => {
  const config = {
    method: 'GET',
    url: API_URL + 'auth/salesforce/pkce',
    headers: { 'Content-Type': 'application/json' },
  };
  const response = await axios(config);
  return response.data;
};
